import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DtpTable,
  DtpTableHeader,
  DtpNoContent,
} from 'dtp-react-components';
import { ExportToCsv } from 'export-to-csv';
import {
  Button,
} from '../../components/index';
import {
  doPost,
} from '../../utils/requests';

class NovoRelatorioExigenciasAnalitico extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNoContent: false,
      noContentPrimaryMessage: null,
      noContentSecondaryMessage: null,
      legendaRelatorio: null,
    };
  }

    gerarCsv = (lista) => {
      if (lista && lista !== undefined && lista.length > 0) {
        const csvExporter = new ExportToCsv({
          filename: 'relatorio',
          fieldSeparator: ';',
          showTitle: true,
          title: this.state.legendaRelatorio,
          showLabels: true,
          headers: this.colunasRelatorio,
        });
        csvExporter.generateCsv(lista);
      }
    };

    // FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
    formatarColuna = (cell, tipo) => {
      let valor = cell;

      if (tipo === 'numero') {
        valor = new Intl.NumberFormat('pt-BR').format(cell);
      } else if (tipo === 'cpf') {
        valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
      } else if (tipo === 'cnpj') {
        valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
      } else if (tipo === 'nit') {
        if (Number.isInteger(cell)) {
          valor = cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
        } else {
          valor = cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
        }
      } else if (tipo === 'protocolo') {
        valor = `'${cell}`;
      }
      return valor.trim();
    }

    prepararColunasExportacao = (data, colunas) => {
      const dados = data.map((item) => {
        const linha = Object.assign({}, item);
        colunas.forEach((c) => {
          const key = Object.keys(item)[c.index];
          const coluna = item[key];
          const colunaFormatada = this.formatarColuna(coluna, c.tipo);
          linha[key] = colunaFormatada;
        });
        return linha;
      });
      return dados;
    }

    pesquisarColunaJson = (json, coluna) => {
      let retorno = json[coluna];
      if (retorno === undefined) {
        retorno = '';
      }
      return retorno;
    }

    colunasRelatorio = [
      'Tipo Exigência',
      'Comentário Exigência',
      'CPF',
      'Protocolo',
      'Nome do beneficiário',
      'Data da abertura',
      'Data da situação',
      'Tipo do requerimento',
    ]

    listaColunasFormatar = [
      { index: 2, tipo: 'cpf' },
      { index: 3, tipo: 'protocolo' },
    ];


    extrairColunasJson = (data) => {
      let objetoLinha = {};
      const dados = data.map((item) => {
        objetoLinha = {
          tipoExigencia: this.pesquisarColunaJson(item, 'tipoExigencia'),
          comentarioExigencia: this.pesquisarColunaJson(item, 'comentarioExigencia') ? this.pesquisarColunaJson(item, 'comentarioExigencia') : '-',
          cpf: this.pesquisarColunaJson(item, 'cpf'),
          protocolo: this.pesquisarColunaJson(item, 'protocolo'),
          nomeBeneficiario: this.pesquisarColunaJson(item, 'nomeBeneficiario'),
          dataAbertura: this.pesquisarColunaJson(item, 'dataAbertura'),
          dataSituacao: this.pesquisarColunaJson(item, 'dataSituacao'),
          tipoRequerimento: this.pesquisarColunaJson(item, 'tipoRequerimento'),
        };
        return objetoLinha;
      });
      return dados;
    }

    tratarSucessoListaExportacao = (response) => {
      if (response.data !== '') {
        const lista = this.extrairColunasJson(response.data);
        const dadosFormatados = this.prepararColunasExportacao(lista, this.listaColunasFormatar);
        this.setState({
        }, this.gerarCsv(dadosFormatados));
      }
    };

    tratarErro = () => {
      const mensagemPrimaria = 'Não foi possível consultar os requerimentos.';
      const mensagemSecundaria = 'Contate o administrador do sistema.';
      this.setState({
        showNoContent: true,
        noContentPrimaryMessage: mensagemPrimaria,
        noContentSecondaryMessage: mensagemSecundaria,
      });
    };

    preparaRequest = (url, parametros) => {
      doPost(
        url,
        parametros,
        this.tratarSucessoListaExportacao,
        this.tratarErro,
      );
    };

    exportarCsv = (props) => {
      this.setState({
        legendaRelatorio: props.legend,
      });
      if (props.urlExportacao && props.parametrosExportacao) {
        const parametros = props.parametrosExportacao;
        parametros['start-position'] = 0;
        parametros['max-results'] = 100000;
        this.preparaRequest(props.urlExportacao, parametros);
      }
    };

    render() {
      if (this.state.showNoContent) {
        return (
          <DtpNoContent
            primaryText={this.state.noContentPrimaryMessage}
            secondaryText={this.state.noContentSecondaryMessage}
            show={this.state.showNoContent}
          />);
      }
      return (
        <React.Fragment>
          {this.props.nomeRelatorio !== '' ? (
            <React.Fragment>
              {this.props.data && this.props.data.length > 0 ? (
                <Button
                  hint="Exportar para CSV"
                  onClick={() => { this.exportarCsv(this.props); }}
                  icon="ico-doc-sheet"
                  mini
                />
                        ) : ''}
              <div className="relatorio" style={{ '--relatorioWidth': this.props.containerStyle.width }}>
                <DtpTable {...this.props}>
                  {this.props.headers.map((item, i) => (
                    <DtpTableHeader
                      key={item}
                      dataField={this.props.data[0] ? Object.keys(this.props.data[0])[i] : 'default'}
                      dataAlign="center"
                      isKey={i === 0}
                      header={item}
                      tdStyle={{ wordBreak: 'break-word' }}
                      dataFormat={this.props.dataFormatOptions[i]}
                      hidden={this.props.options.hidden && this.props.options.hidden.includes(i)}
                    />))}
                </DtpTable>
              </div>
            </React.Fragment>
                ) : null
                }
        </React.Fragment>
      );
    }
}

NovoRelatorioExigenciasAnalitico.propTypes = {
  dataFormatOptions: PropTypes.object,
}.isRequired;

NovoRelatorioExigenciasAnalitico.defaultProps = {
  voltarAction: () => null,
};

export default NovoRelatorioExigenciasAnalitico;



// WEBPACK FOOTER //
// ./src/pages/relatorios/NovoRelatorioExigenciasAnalitico.jsx